/**
 * Footer newsletter signup — Klaviyo version.
 * Same behaviour and design as before, but the email goes to Klaviyo
 * (list "Liste d'adresses e-mail"), which then syncs it back to Shopify.
 */
const KLAVIYO_COMPANY_ID = "TVazWp";
const KLAVIYO_LIST_ID = "UGBDbZ";
const KLAVIYO_SOURCE = "TURN Footer";

class FooterNewsletter extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.message = this.querySelector("[data-newsletter-message]");
    this.form?.addEventListener("submit", (event) => this.onSubmit(event));
  }

  async onSubmit(event) {
    event.preventDefault();

    const input = this.form.querySelector('input[type="email"]');
    if (!input?.value || !input.checkValidity()) {
      this.showMessage(this.dataset.messageInvalid, true);
      return;
    }

    const submitButton = this.form.querySelector('[type="submit"]');
    submitButton?.setAttribute("disabled", "disabled");

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions?company_id=${KLAVIYO_COMPANY_ID}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/vnd.api+json",
            Accept: "application/vnd.api+json",
            revision: "2024-10-15",
          },
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                custom_source: KLAVIYO_SOURCE,
                profile: {
                  data: {
                    type: "profile",
                    attributes: { email: input.value.trim() },
                  },
                },
              },
              relationships: {
                list: { data: { type: "list", id: KLAVIYO_LIST_ID } },
              },
            },
          }),
        }
      );

      if (response.ok) {
        this.form.style.visibility = "hidden";
        this.showMessage(this.dataset.messageSuccess, false);
      } else {
        this.showMessage(this.dataset.messageInvalid, true);
        submitButton?.removeAttribute("disabled");
      }
    } catch (error) {
      console.error("Footer newsletter signup failed", error);
      this.showMessage(this.dataset.messageError, true);
      submitButton?.removeAttribute("disabled");
    }
  }

  showMessage(text, isError) {
    if (!this.message) return;
    this.message.textContent = text || "";
    this.message.hidden = !text;
        this.message.classList.toggle("footer-newsletter__message--error", !!isError);
  }
}

customElements.define("footer-newsletter", FooterNewsletter); 